<template>

    <section id="form-section">

      <div class="box is-shadowless">

        <h1 class="title is-3">Inspections</h1>

        <div class="columns">

          <div class="column">

            <!-- The google map gets loaded here -->
            <!-- <div ref="gmap" class="google-map"></div> -->

            <!--
            <figure class="image is-3by1">
              <img src="https://swtest.aklc.net/placeholder-map-1080x360.png" alt="Map">
            </figure>
            -->
            <forms-map :forms="denormalizedForms" />
          </div>

        </div>


        <div class="box">
          <button class="button is-info" @click.prevent.stop="onToggleFilters">Toggle Filters</button>
        </div>

        <div v-show="showFilters" class="box has-background-light">

          <form @submit.prevent="onFilter">

            <div class="columns is-mobile is-multiline">

              <div class="column is-half">

                <base-select
                  v-model="filter.contractType"
                  :service="$options.contractService"
                  fetch-func="listTypes"
                  :fetch-params="{
                    created_by_firm_id: $store.state.Auth.user.firmId,
                  }"
                  label="Contract Type"
                  default-option-label="All"
                  custom-class="is-small"
                />

              </div>

              <div class="column is-half">

                <base-select
                  v-model="filter.contract"
                  :service="$options.contractService"
                  fetch-func="all"
                  :fetch-params="{
                    type_tag_id: filter.contractType || undefined,
                    includes: 'contractor',
                  }"
                  label="Contract"
                  default-option-label="All"
                  custom-class="is-small"
                  ref="selectContract"
                >
                  <template #customLabel="{ option }">
                    {{ `${option.contractor.name} - ${option.name}` }}
                  </template>
                </base-select>

              </div>

              <div class="column is-half">

                <b-field label="Form type" custom-class="is-small">
                  <b-select placeholder="Select" v-model="filter.formType" expanded>
                    <option
                        :key="i"
                        :value="option.value"
                        v-for="(option, i) in types">{{option.text}}</option>
                  </b-select>
                </b-field>

              </div>

              <div class="column is-half">

                <b-field label="Form ID" custom-class="is-small">
                  <b-input placeholder="001234" v-model="filter.formId"></b-input>
                </b-field>

              </div>

              <!--
              <div class="column is-half">

                <b-field label="Subregion" custom-class="is-small">
                  <b-select placeholder="Select" v-model="filter.subregion" expanded>
                    <option :key="i"
                        :value="option.value"
                        v-for="(option, i) in subregions">{{option.text}}</option>
                  </b-select>
                </b-field>

              </div>
              -->

              <div class="column is-half">

                <!-- <b-field custom-class="is-small">
                  <template #label>
                    Asset class <span class="has-text-danger">*</span>
                  </template>
                  <b-select v-model="filter.assetClass" expanded>
                    <option :value="null">Please Select</option>
                    <option
                        :key="i"
                        :value="option.value"
                        v-for="(option, i) in assetClasses">{{option.text}}</option>
                  </b-select>
                </b-field> -->

                <base-select
                  v-model="filter.assetClass"
                  :service="$options.codeService"
                  fetch-func="childIntersection"
                  :fetch-params="{
                    group: 'INSP',
                    type: 'ASSET',
                    intersect: 0,
                    firm_id: $store.state.Auth.user.firmId,
                  }"
                  value-key="code"
                  custom-class="is-small"
                >
                  <template #label>
                    Asset class <span class="has-text-danger">*</span>
                  </template>
                </base-select>

              </div>

              <div class="column is-half">

                <b-field label="Asset ID" custom-class="is-small">
                  <b-input placeholder="Asset ID" v-model="filter.assetId"></b-input>
                </b-field>

              </div>

              <div class="column is-half">

                <b-field label="Inspection date start" custom-class="is-small">
                  <b-datepicker id="start"
                      v-model="filter.complete_start"
                      icon="calendar"
                      :date-formatter="dateFormatter">
                  </b-datepicker>
                </b-field>

              </div>

              <div class="column is-half">

                <b-field label="Inspection date end" custom-class="is-small">
                  <b-datepicker id="end"
                      v-model="filter.complete_end"
                      icon="calendar"
                      :date-formatter="dateFormatter">
                  </b-datepicker>
                </b-field>

              </div>

              <div class="column is-half">

                <b-field label="Work Order Number" custom-class="is-small">
                  <b-input placeholder="Work Order Number" v-model="filter.workOrderNo"></b-input>
                </b-field>

              </div>

              <div class="column is-half">

                <b-field label="Work Order Description" custom-class="is-small">
                  <b-input placeholder="Work Order Description" v-model="filter.workOrderDescription"></b-input>
                </b-field>

              </div>

              <div class="column is-half">

                <b-field label="Work Order Date Start" custom-class="is-small">
                  <b-datepicker
                      v-model="filter.work_order_date_start"
                      icon="calendar"
                      :date-formatter="dateFormatter">
                  </b-datepicker>
                </b-field>

              </div>

              <div class="column is-half">

                <b-field label="Work Order Date End" custom-class="is-small">
                  <b-datepicker
                      v-model="filter.work_order_date_end"
                      icon="calendar"
                      :date-formatter="dateFormatter">
                  </b-datepicker>
                </b-field>

              </div>

              <!--
              <div class="column is-half">

                <b-field label="Region" custom-class="is-small">
                  <b-select placeholder="Region" v-model="filter.region" expanded>
                    <option :key="i"
                        :value="option.value"
                        v-for="(option, i) in regions">{{option.text}}</option>
                  </b-select>
                </b-field>

              </div>
              -->

              <div class="column is-half">

                <b-field label="Engineer Required" custom-class="is-small">
                  <b-select placeholder="Select" v-model="filter.engineer_required" expanded>
                    <option value="">Select</option>
                    <option value="1">Yes</option>
                    <option value="0">No</option>
                  </b-select>
                </b-field>

              </div>

              <div class="column is-half">

                <div class="field">

                  <label class="label is-small">Further Work Required - Incomplete</label>

                  <div class="control">

                    <b-switch size="is-medium" v-model="filter.further_work_incomplete" :true-value="1" :false-value="0"></b-switch>

                  </div>

                </div>

              </div>

              <div class="column is-half">

                <b-field>
                  <div class="has-addons">
                    <button
                      id="submit_order_filter"
                      name="submit_order_filter"
                      class="button is-info"
                      type="submit"
                    >
                      <i class="fa fa-filter"></i> &nbsp; Filter
                    </button>
                    <button @click="onReset()" class="button is-info"><i class="fa fa-refresh"></i> &nbsp; Reset</button>
                  </div>
                </b-field>

              </div>

              <div class="column is-half">

                <!-- Nothing at the moment -->

              </div>

            </div> <!-- .columns -->

          </form>

        </div> <!-- .box (filters) -->

        <div v-if="denormalizedForms.length">

          <!-- NOTE: Had some trouble using buefy table. Table headers could disappear when content changes -->
          <!-- https://stackoverflow.com/questions/52932895/buefy-table-headers-dissapear -->
          <!-- https://github.com/buefy/buefy/issues/992 -->
          <!-- (so using normal table for now) -->
          <table class="table is-fullwidth">

            <thead>
              <tr>
                <th>ID</th>
                <th>Work Order</th>
                <th>Date</th>
                <th>Type</th>
                <th>Status</th>
                <th>
                  <!-- Actions -->
                  <button @click="onExport()" class="button is-warning">
                    <i class="fa fa-download"></i>
                    &nbsp; Export
                  </button>
                </th>
              </tr>
            </thead>

            <tbody>

              <tr v-for="form in denormalizedForms" :key="form.id">

                <td>
                  <router-link :to="{ name: 'form-show', params: { id: form.id}}" title="View">{{form.id_alt}}</router-link>
                </td>
                <td>{{ form.order.orderId }}</td>
                <td>{{ form.completed_at | toLocalDateAndTime }}</td>
                <td>{{form.type.text}}</td>
                <td>
                  <small v-if="form.status === 'SUBMITTED'" class="tag is-success">{{form.status}}</small>
                  <small v-if="form.status === 'VOID'" class="tag is-warning">{{form.status}}</small>
                  <small v-if="form.status === 'DRAFT'" class="tag is-info">{{form.status}}</small>
                </td>
                <td>
                  <router-link :to="{ name: 'form-edit', params: { id: form.id}}" :disabled=" ! can('update', form)" class="button is-info" title="Edit Form">Edit</router-link>
                  &nbsp;
                  <button @click.prevent="confirmDelete(form.id, 'Delete this form?')" :disabled=" ! can('delete', form)" type="submit" class="button is-danger" title="Delete Form">Delete</button>
                  <!-- <button v-if="form.status == 'DRAFT' && form.status != 'VOID' " @click.prevent="confirmVoid(form.id, 'Void this form?')" type="submit" class="button is-warning" title="Void Form"><i class="fa fa-ban"></i></button> -->
                </td>
              </tr>

            </tbody>

          </table>

        </div>

        <p v-else>
          No results found.
        </p>

      </div> <!-- .box (main box) -->

    </section>
</template>

<style scoped>
  .google-map {
    background: url('https://cdnjs.cloudflare.com/ajax/libs/file-uploader/3.7.0/processing.gif') center center no-repeat;
    height: 360px;
    width: 100%;
  }
</style>

<script>
import * as moment from "moment";
import BaseSelect from "@/components/partials/BaseSelect";
import ContractSelect from "@/components/Contract/ContractSelect";
import FormsMap from "./partials/map";
import { AuthService } from "@/services/auth.service.js";
import { CodeService } from "@/services/code.service.js";
import { ContractService } from "@/services/contract.service.js";
import { FormService } from "@/services/form.service.js";
import { OrderService } from "@/services/order.service.js";
import { FormTransformer } from "@/helpers/forms/form.transformer";
import { DataTransformer } from "@/helpers/orders/data.transformer.js";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer.js";
import { AssetClass } from "@/helpers/asset-class-options.js";
const OrderTransformer = DataTransformer;  // more convenient alias...

export default {
  name: "forms",
  codeService: CodeService,
  contractService: ContractService,
  components: {
    BaseSelect,
    ContractSelect,
    FormsMap
  },
  data() {
    return {
      environment: '',
      googleMapsJsLoaded: false,
      showFilters: false,
      error: "",
      types: [],
      type: "",
      filter: {
        contractType: "",
        contract: "",
        formType: "",
        formTypeVersionId: null,
        formId: "",
        assetClass: null,
        assetId: "",
        subregion: "",
        workOrderNo: "",
        workOrderDescription: "",
        region: "",
        complete_start: null,
        complete_end: null,
        work_order_date_start: null,
        work_order_date_end: null,
        engineer_required: "",
        further_work_incomplete: 0
      },
      denormalizedForms: [],
      formData: [],
      assetClasses: [],
      subregions: [],
      regions: [],
      loading: false
    };
  },
  watch: {
    "filter.contractType"() {
      this.filter.contract = "";
      this.$nextTick(() => {
        this.$refs.selectContract.fetchOptions();
      });
    },
    formData: function(newVal, oldVal) {

      // this.updateGoogleMap();
    }
  },
  computed: {
    filterQueryParams() {
      let params = {};
      // Some of local filter names don't map directly to the API filter names...
      const map = {
        // local:api
        contractType: 'contract_type_id',
        contract: 'contract_id',
        formType: 'type',
        formId: 'form_id',
        assetClass: 'asset_class',
        assetId: 'asset_code',
        subregion: 'sub_region',
        workOrderNo: 'order_id',
        workOrderDescription: 'work_order_description',
      }
      _.forEach(this.$data.filter, (val, key) => {
        const query_key = map.hasOwnProperty(key)
          ? map[key]
          : key;
        params[query_key] = val;
      });
      const dates = ['complete_start', 'complete_end', 'work_order_date_start', 'work_order_date_end'];
      const start_dates = ['complete_start', 'work_order_date_start'];
      const end_dates = ['complete_end', 'work_order_date_end'];
      dates.forEach(field => {
        const value = _.get(params, field);
        if (value instanceof Date) {
          const m = moment(value);
          if (start_dates.indexOf(field) >= 0) m.startOf('day');
          if (end_dates.indexOf(field) >= 0) m.endOf('day');
          params[field] = m.toISOString();
        }
      });
      // return params;
      return _.omitBy(params, _.isNil);
    },
    csvExportQueryParams() {
      const params = Object.assign({}, this.filter, { type: this.filter.formType} );
      const dates = ['complete_start', 'complete_end', 'work_order_date_start', 'work_order_date_end'];
      const start_dates = ['complete_start', 'work_order_date_start'];
      const end_dates = ['complete_end', 'work_order_date_end'];
      dates.forEach(field => {
        const value = _.get(params, field);
        if (value instanceof Date) {
          const m = moment(value);
          if (start_dates.indexOf(field) >= 0) m.startOf('day');
          if (end_dates.indexOf(field) >= 0) m.endOf('day');
          params[field] = m.toISOString();
        }
      });
      // Remove undefined/null values from the params.
      // Otherwise the FormService.exportAsCsv() method converts these to x=undefined/null in the URL)
      // @todo - use package like Qs for converting objects to query string parameters
      return _.omitBy(params, _.isNil);
    }
  },
  mounted() {
    this.$data.environment = process.env.ENVIRONMENT || 'production';
    this.restoreLocalFilters();
    if (!!localStorage.getItem('formFilter')) {
      this.$data.showFilters = true;
    } else {
      this.$data.showFilters = false;
    }
    // this.assetClasses = AssetClass.options();
    this.loadFormTypes();
    this.setDefaultDateRange();
    this.$nextTick(() => {
      this.loadFormData();
    });
    // this.loadSubRegions();
    // this.listRegions();
    /* if (window.google && google.load) {
      google.load('maps', '3', {callback: this.onGoogleMapsLoaded, other_params:`key=${process.env.GOOGLE_API_KEY}`});
    } */
  },
  beforeDestroy() {

    // ----------------------------------------------------
    // START Clean up event listeners and intervals etc.
    // ----------------------------------------------------

    // Clear up the google map event listeners
    if (this.gmap !== undefined) {

      google.maps.event.clearListeners(this.gmap, 'click');

      if (Array.isArray(this.gmarkers)) {

        this.gmarkers.forEach(m => {

          google.maps.event.clearListeners(m, 'click');
        });
      }
    }

    // ----------------------------------------------------
    // END Clean up event listeners and intervals etc.
    // ----------------------------------------------------
  },
  methods: {
    onToggleFilters() {
      this.$data.showFilters = ! this.$data.showFilters;
    },
    listRegions() {
      this.regions.push({
        value: "",
        text: "Select"
      });
      OrderService.findRegions().then(res => {
        res.data.forEach(reg =>
          this.regions.push({
            value: reg.code,
            text: reg.code
          })
        );
      });
    },
    loadSubRegions() {
      this.subregions.push({
        value: "",
        text: "Select"
      });
      FormService.all({ get_subregion: true }).then(res => {
        res.data.forEach(sub =>
          this.subregions.push({
            value: sub.code,
            text: sub.code
          })
        );
      });
    },
    setDefaultDateRange() {
      this.filter.work_order_date_start = moment().subtract(3, "months").startOf("month").toDate();
      this.filter.work_order_date_end = moment().toDate();
    },
    loadFormData() {
      // if (!this.filter.assetClass) return;
      this.loading = true;
      FormService.all(Object.assign({}, this.filterQueryParams, {includes: 'order'})).then(res => {
        this.formData = FormTransformer.transformArray(res.data);
        this.$data.denormalizedForms = JsonDenormalizer.denormalize(res);
        // this.updateGoogleMap();
        this.loading = false;
      });
    },
    loadFormTypes() {
      FormService.listFormTypes().then(res => {
        this.types.push({
          value: "",
          text: "Select"
        });
        res.data.forEach(type => {
          this.types.push({
            value: type.id,
            text: type.attributes.name
          });
        });
      });
    },
    onSelectFormType(type) {
      this.type = type;
    },
    onSubmit() {
      if (!this.type) {
        this.$buefy.dialog.alert({
          title: "Form type is required.",
          message: "Ooops, you need to select a form type.",
          type: "is-danger"
        });
      } else {
        FormService.store({ form_type_id: this.type, status: "DRAFT" }).then(
          res => {
            this.$router.push({
              name: "form-edit",
              params: { id: res.data.id }
            });
          }
        );
      }
    },
    confirmDelete(id, message) {
      this.$buefy.dialog.confirm({
        message,
        onConfirm: () => this.deleteForm(id)
      });
    },
    deleteForm(id) {
      FormService.delete(id).then(res => {
        this.$buefy.toast.open("Form deleted!");
        this.loadFormData();
      });
    },
    confirmVoid(id, message) {
      this.$buefy.dialog.confirm({
        message,
        onConfirm: () => this.voidForm(id)
      });
    },
    voidForm(id) {
      FormService.update(id, { status: "VOID" }).then(res => {
        this.$buefy.toast.open("Form voided!");
        this.loadFormData();
      });
    },
    onFilter() {
      this.saveLocalFilters();
      this.loadFormData();
    },
    saveLocalFilters() {
      let filter = {};
      _.forEach(this.$data.filter, (val, key) => {
        if (val instanceof Date) {
          filter[key] = 'DATE:' + moment(val).toISOString();
        }
        else {
          filter[key] = val;
        }
      });
      if (Object.keys(filter).length) {
        localStorage.setItem('formFilter', JSON.stringify(filter));
      }
    },
    restoreLocalFilters() {
      let filter = {}
      const formFilter = localStorage.getItem('formFilter');
      const local = formFilter
        ? JSON.parse(formFilter)
        : {};
      _.forEach(local, (val, key) => {
        if (_.isString(val) && val.indexOf('DATE:') === 0) {
          const m = moment(val.substring(5));
          if (m.isValid()) filter[key] = m.toDate();
        }
        else {
          filter[key] = val;
        }
      });
      this.$data.filter = Object.assign({}, this.$data.filter, filter);
    },
    clearLocalFilters() {
      localStorage.removeItem('formFilter');
    },
    onReset() {
      this.filter = {};
      this.clearLocalFilters();
      this.denormalizedForms = [];
      this.formData = [];
      this.loadFormData();
    },
    onExport() {
      if(!this.filter.formType) {
        this.$buefy.toast.open({
          message: "Please filter by form type before exporting.",
          duration: 3000
        });
      } else {

        AuthService.tokenDownload()
          .then(token => {

            let url = FormService.exportAsCsv(this.filterQueryParams) + `&bearerToken=${encodeURIComponent(token)}`;

            window.open(url, '_blank');
          })
          .catch(err => {

            this.$buefy.toast.open({
              message: 'Failed to generate a download link.',
              type: 'is-danger'
            });
          });
      }
    },
    onGoogleMapsLoaded() {
      this.$data.googleMapsJsLoaded = true;
    },
    updateGoogleMap: _.debounce(function() {

      // USEFUL:
      // https://stackoverflow.com/questions/3059044/google-maps-js-api-v3-simple-multiple-marker-example

      const vm = this;

      if ( ! this.$data.googleMapsJsLoaded) return;

      // We may be about to update an existing map so need to be able to reset our marker array.
      // (and to do this, we need to remove the marker from its associated map BEFORE reset)
      if (_.isArray(vm.gmarkers)) {

        vm.gmarkers.forEach(m => {
          m.setMap(null);
        });
      }

      vm.gmarkers = [];

      // We use nextTick here to help ensure that vm.$refs are ready to use.
      vm.$nextTick(() => {

        // Default map center if no inspection form data available
        // (e.g. no inspection forms match the search criteria)
        const defaultCenter = new google.maps.LatLng(-36.846654, 174.754156);  // Auckland City

        // Prepare array of useful location data for creating markers
        // (also prepare the google map bounds object in the loop)
        let locations = [];
        const bounds = new google.maps.LatLngBounds();

        this.$data.formData.forEach(form => {

          if ( ! form.asset_lat || ! form.asset_lng) return;

          let title = `Inspection #${form.id}`;

          if (form.asset_name) title += `: ${form.asset_name}`;

          let location = {id: form.id, title, lat: form.asset_lat, lng: form.asset_lng};

          locations.push(location);
          bounds.extend(new google.maps.LatLng(location.lat, location.lng));
        });

        // If an instance of the google map doesn't exist, create it
        // (otherwise we may simply be updating the existing map)
        if ( ! vm.gmap) {

          // Default to Auckland as the center of the map but override immediately
          // if we have coordinates available from existing inspection form data
          // (we'll also be setting bounds if we have multiple markers anyway)
          let centerLatLng = locations.length ? new google.maps.LatLng(locations[0].lat, locations[0].lng) : defaultCenter;

          vm.gmap = new google.maps.Map(
            vm.$refs.gmap,
            {
              zoom: 12,
              center: centerLatLng,
              mapTypeId: google.maps.MapTypeId.ROADMAP,  // SATELLITE, ROADMAP, HYBRID, TERRAIN
              tilt: 0,
              disableDefaultUI: true,
              zoomControl: true,
              styles: [
                {featureType: "poi", stylers: [{ visibility: "off" }]},
                {featureType: "transit", elementType: "labels.icon", stylers: [{visibility: "off"}]}
              ]
            }
          );
        }

        // Attempt to center the map across all the markers
        if (locations.length > 1) {

          vm.gmap.fitBounds(bounds);
        }
        else {

          // Using fitBounds with only one marker results in crazy zoom in
          // (so we use a custom zoom and manual setCenter here instead)
          let recenter = ! locations.length ? defaultCenter : {lat: parseFloat(locations[0].lat), lng: parseFloat(locations[0].lng)};

          vm.gmap.setZoom(12);
          vm.gmap.setCenter(recenter);
        }

        const infowindow = new google.maps.InfoWindow();
        let marker, i;

        for (i = 0; i < locations.length; i++) {

          marker = new google.maps.Marker({
            position: new google.maps.LatLng(locations[i].lat, locations[i].lng),
            title: locations[i].title,
            // animation: google.maps.Animation.DROP,
            map: vm.gmap  // can also use marker.setMap(theMap)
          });

          // Keep a reference to the marker for future use
          // (things like removing event listeners etc.)
          vm.gmarkers.push(marker);

          google.maps.event.addListener(marker, 'click', (function(marker, i) {
            return function() {
              const contentString = `<p><strong>${locations[i].title}</strong> <br> <a href="/forms/${locations[i].id}" class="google-map-marker-link" data-id="${locations[i].id}">View</a> </p>`;
              infowindow.setContent(contentString);
              infowindow.open(vm.gmap, marker);
            }
          })(marker, i));
        }
      });
    }, 1000),
    can(action, form) {

      let allow = false;
      action = action.toUpperCase();

      switch (action) {

        case 'UPDATE':
        case 'DELETE':
          allow = (
            form.status.toUpperCase() != 'SUBMITTED'
            &&
            this.$store.getters['Auth/hasPermission']('can manage inspections')
          );
          break;
        default:
          allow = false;
      }

      return allow;
    },
    dateFormatter(date) {

      // Used with the buefy datepicker component date-formatter property.
      return moment(date).format('DD-MMM-YYYY');
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/pages/Forms/list/index.vue